export const formSchemaEndpoints = {
  getAll: "/schemas",
  getById: (id) => `/schemas/${id}`,
  getBySector: (sector) => `/schemas/sector/${sector}`,
  create: "/schemas",
  update: (id) => `/schemas/${id}`,
  delete: (id) => `/schemas/${id}`,
};

